
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core'
import { DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { SidenavComponent } from './layouts/sidenav/sidenav.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { HeaderComponent } from './layouts/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSidenavModule} from '@angular/material/sidenav';
// import {MatListModule} from '@angular/material/list'
// import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle'
// import {CdkTableModule} from '@angular/cdk/table';


// import {NgModule} from '@angular/core';
import {A11yModule} from '@angular/cdk/a11y';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
// import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
// import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {OverlayModule} from '@angular/cdk/overlay';
import { HomeComponent } from './home/home.component';
import { TabComponent } from './tabs/tab.component';
import { TabsComponent } from './tabs/tabs.component';
import { DynamicComponentComponent } from './layouts/dynamic-component/dynamic-component.component';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { CustomInterceptor } from './azure-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IPublicClientApplication, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import {  MsalModule ,MsalRedirectComponent, MsalGuardConfiguration, MsalInterceptorConfiguration} from '@azure/msal-angular';
import { LayoutModule } from './layouts/layout.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { Sample1Component } from './sample1/sample1.component';
import { Sample2Component } from './sample2/sample2.component';
import { Sample3Component } from './sample3/sample3.component';
import { Sample4Component } from './sample4/sample4.component';
import { CreateNewSRComponent } from './NewServiceRequest/create-new-sr/create-new-sr.component';



import { provideUserIdleConfig } from 'angular-user-idle';
import { UserIdleService } from 'angular-user-idle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsPopupComponent } from './settings-popup/settings-popup.component';
import { NetworkStatusComponent } from './network-status/network-status.component';
import { NetworkService } from './services/network-service/network-service';
// import { AttachmentsViewComponent } from './attachments/attachments-view/attachments-view.component';








const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      // clientId: '6226576d-37e9-49eb-b201-ec1eeb0029b6', // Prod enviroment. Uncomment to use.
      clientId: environment.clientId, // PPE testing environment
      // authority: 'https://login.microsoftonline.com/common', // Prod environment. Uncomment to use.
      authority: environment.msalAuthority, // PPE testing environment.
      redirectUri: '/',
      postLogoutRedirectUri: '/',
      // knownAuthorities:['https://smartchstsme.b2clogin.com']
      knownAuthorities:['https://fortwayne311.b2clogin.com']
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
  // protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['openid','profile']);
  protectedResourceMap.set('https://graph.microsoft.com/', ['openid']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      // scopes: ['user.read']
      scopes: ['openid', 'profile']
      // scopes:['6b49ecf4-0a76-4526-b4af-97565de86af0']
    },

    // authRequest?: MsalGuardAuthRequest | ((authService: MsalService, state: RouterStateSnapshot) => MsalGuardAuthRequest);

    // loginFailedRoute: '/login-failed'
    // loginFailedRoute: '/forgot-pw'

  };
}

// import {
//   PERFECT_SCROLLBAR_CONFIG,
//   PerfectScrollbarConfigInterface,
//   PerfectScrollbarModule,
// } from 'ngx-perfect-scrollbar';

@NgModule({
  declarations: [
    AppComponent,
    SettingsPopupComponent,
    NetworkStatusComponent,
    // AttachmentsViewComponent



    // Sample1Component,
    // Sample2Component,
    // Sample3Component,
    // Sample4Component,
    // SidenavComponent,
    // FooterComponent,
    // HeaderComponent,
    // HomeComponent,
    // TabsComponent,
    // TabComponent,
    // DynamicComponentComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    NgHttpLoaderModule.forRoot()

  ],
  schemas: [
    // CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
     provideUserIdleConfig({ idle: 3570, timeout: 20, ping: 120 }),

     {
     provide: HTTP_INTERCEPTORS,
     useClass: MsalInterceptor,
     multi: true
     },
     {
     provide: HTTP_INTERCEPTORS,
     useClass: CustomInterceptor,
     multi: true
     },
     {
     provide: MSAL_INSTANCE,
     useFactory: MSALInstanceFactory
     },
     {
     provide: MSAL_GUARD_CONFIG,
     useFactory: MSALGuardConfigFactory
     },
     {
     provide: MSAL_INTERCEPTOR_CONFIG,
     useFactory: MSALInterceptorConfigFactory
     }
     ,MsalService,
     MsalGuard,
     MsalBroadcastService,
     DatePipe,
     NetworkService
    ],
  exports:[
    // TabsComponent,
    // TabComponent,
  ],
  entryComponents:[
    // TabComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
